import React from "react";
import ReactDOM from "react-dom/client";
import App from "./App";
import { UserProvider } from "./Components/Context/UserContext";

/**
 * Main entry point for the React application
 * Renders the App component wrapped with UserProvider for global state management
 */
const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <UserProvider>
    <App />
  </UserProvider>
);
